var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dependency-toggle-button",class:{
    'is-blocked': _vm.type === 'blocked',
    'waiting-on': _vm.type === 'waiting',
  }},[_c('CommonIcon',{attrs:{"id":"minus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }